<!--
    Auf- und zuklappen mit animierter Höhe. Portiert aus aesthetify, aber ohne
    @bam/transitions: die Paketversion setzt `v(duration-appear)` und damit
    --bam-*-Tokens, die es in diesem Projekt nicht gibt — die Übergänge wären
    ohne Dauer und damit unsichtbar.

    `height: auto` ist nicht interpolierbar, deshalb wird die Zielhöhe gemessen,
    animiert und danach wieder auf `auto` gestellt, damit der Inhalt weiter
    mitwachsen kann (Umbruch bei Resize, nachgeladene Bilder).

    Das zugehörige CSS steht in scss/components/_transitions.scss.
-->
<script setup>
const enter = (element) => {
    element.style.height = "0px";
    // Erzwingt den Startwert. Ohne diesen Lesezugriff fasst der Browser beide
    // Zuweisungen zu einem Schritt zusammen und es gibt keinen Übergang.
    void element.offsetHeight;
    element.style.height = `${element.scrollHeight}px`;
};

const afterEnter = (element) => {
    element.style.height = "auto";
};

const leave = (element) => {
    element.style.height = `${element.scrollHeight}px`;
    void element.offsetHeight;
    element.style.height = "0px";
};

const afterLeave = (element) => {
    element.style.height = "";
};
</script>

<template>
    <Transition
        name="expand"
        @enter="enter"
        @after-enter="afterEnter"
        @leave="leave"
        @after-leave="afterLeave"
    >
        <slot />
    </Transition>
</template>
